import { FC } from 'react';
import { useEditorContext } from '../../Editor/Context';
import Reaction from '../buttons/Reaction';
import Deviation from '../buttons/Deviation';
import Gif from '../buttons/Gif';
import { useForceUpdate } from '../../../hooks/useForceUpdate';
import cn from 'classnames';
import Gallery from '../buttons/Gallery';
import Video from '../buttons/Video';

import s from './PluginInsertMenu.scss';

export interface Props {
  className?: string;
}

const PluginInsertMenu: FC<Props> = ({ className }) => {
  const editor = useEditorContext();
  const forceUpdate = useForceUpdate();

  // Listen to editor as its not react so we need to react here
  editor?.on('transaction', () => {
    forceUpdate();
  });

  if (!editor) {
    return null;
  }

  return (
    <div className={cn(s['root'], className)}>
      <Reaction editor={editor} />
      <Deviation editor={editor} />
      <Gallery editor={editor} />
      <Gif editor={editor} />
      <Video editor={editor} />
    </div>
  );
};
PluginInsertMenu.displayName = 'PluginInsertMenu';

export default PluginInsertMenu;
